module.exports = __webpack_public_path__ + "static/media/image-user-3.5b726e96.jpg";